'use client';

import View from '../view';
import { Link } from '@/navigation';
import { motion } from 'framer-motion';
import { Image } from '@nextui-org/react';
import css from './style/card.module.scss';
import { mountAnimation } from '@/config/animation';
import React from 'react';

type Props = {
  image?: string | null;
  title: string | null;
  href: {
    pathname: string;
    params: Record<string, any>;
  };
  description: string | null;
};

const AnimatedCard = ({ title, image, href }: Props) => {
  return (
    <Link href={href as any}>
      <motion.div
        className={css['card']}
        {...mountAnimation}
        transition={{
          delay: 0.2,
          duration: 0.4,
        }}
      >
        <Image
          radius="none"
          removeWrapper
          src={image!}
          alt={title!}
          className="h-full w-full object-cover"
          classNames={{
            img: 'h-full w-full object-cover',
          }}
        />
        <View className={css['text-layer']}>
          <View className={css['text-content']}>
            <span className="font-bold text-xl">{title}</span>
          </View>
        </View>
      </motion.div>
    </Link>
  );
};

export default AnimatedCard;
